<footer>
  <div *ngIf="env" class="container">
    <p>{{ env.copyright }}</p>
    <p>{{ env.server }}</p>
    <p>
      {{ env.version }} | {{ env.build }} |
      <a
        class="accessible-footer-link"
        href="http://www.ucdmc.ucdavis.edu/legal/"
        target="_blank"
        >Legal</a
      >
      |
      <a
        class="accessible-footer-link"
        _ngcontent-c0=""
        href="http://www.ucdmc.ucdavis.edu/legal/privacy"
        target="_blank"
        >Privacy</a
      >
    </p>
  </div>
</footer>
